import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Injector, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormsModule, NgForm, FormGroupName } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Dialog } from 'primeng/dialog';
import { ProgressService } from 'src/app/common/progress.service';
import { ResumeService } from  '../../services/resume.service';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { CommonService } from 'src/app/services/common.service';
import { AlertService } from 'src/app/common/alert.service';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { Global } from 'src/app/Global';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource} from '@angular/material/table';
import { MatDialogConfig} from '@angular/material/dialog';
import {  } from '@angular/material';
import { DataService } from 'src/app/common/data.service';
import { saveAs } from 'file-saver';
import { EducationDetails } from 'src/app/model/resume-request-detail';
import {DatePipe} from '@angular/common';
import { Action } from 'rxjs/internal/scheduler/Action';
enum Actions {
    New = 0,
    SaveasDraft = 1,
    Submit = 2,
    PendingForApproal = 3
}
@Component({
    selector: 'app-resume',
    templateUrl: './resume.component.html',
    styleUrls: ['./resume.component.css']
})
export class ResumeComponent implements OnInit {
    ResumeDataSource: MatTableDataSource<any[]>;
    public imagePath;
    imgURL: any;
    @ViewChild('modalContent') modalContent: TemplateRef<any>;
    SelectedEngSectorList: Array<any> = [];
    EngSectorList: Array<any> = [];
    EngTypeList: Array<any> = [];
    SelectedEngTypeList: Array<any> = [];
    YearOfExperience: Array<any> = [];
    ResumeCreationForm: FormGroup;
    EducationDetailForm: FormGroup;
    UploadResponseFileUpload: File;
    uploadedFiles: any = '';
    ResID: number;
    file: File;
    EmpGPN: string;
    formData: FormData;
    resumeID: string;
    empLPN: string;
    employeeList: any;
    StatusDesc: string = "";
    ViewMandateSelection: boolean = false;
    VisibleEducationDialog: boolean = false;
    VisibleprevWorkDialog: boolean = false;
    blockedUI: boolean = true;
    mandateColumns: any = [
        { field: 'ResumeId', header: 'ResumeId', hidden: true },
        { field: 'IsSelected', header: '', hidden: false },
        { field: 'Priority', header: 'Priority', hidden: false },
        { field: 'ID', header: 'ID', hidden: true },
        { field: 'EngagementType', header: 'Engagement Type', hidden: false },
        { field: 'ClientName', header: 'Client Name', hidden: false },
        { field: 'ProjectName', header: 'Project Name', hidden: false },
        { field: 'StartDate', header: 'Start Date', hidden: false }]

    educationColumns: any = [
        { field: 'ResumeId', header: 'ResumeId', hidden: true },
        { field: 'Qualification', header: 'Qualification' },
        { field: 'CourseName', header: 'Course Name' },
        { field: 'CountryName', header: 'Country' },
        { field: 'CityName', header: 'City' },
        { field: 'CourseType', header: 'Course Type' }];
    PrevWorkColumns: any = [
        { field: 'ResumeId', header: 'ResumeId', hidden: true },
        { field: 'CompanyName', header: 'Company Name' },
        { field: 'FromDate', header: 'From Date' },
        { field: 'ToDate', header: 'To Date' },
        { field: 'PositionHeld', header: 'Position Held' },
        { field: 'CountryName', header: 'Country' },
        { field: 'CityName', header: 'City' }];
    Mandates: any = [];
    CountryList: any;
    QualificationList: any;
    CourseTypeList: any;
    CityList: any;
    CourseList: any;
    selectedMandates: any = [];
    selectedEduDetails: any = [];
    selectedPrevWorkDetails: any = [];
    CanSaveForm: boolean = false;
    CanEditForm: boolean = false;
    CanApproveRejectForm: boolean = false;
    IsFormEditable: boolean = false;

    showPreviewProgress = false;
    downloadButtonTitle = 'Downloading';
    displaySelectedSlidePreviewDialog = false;
    slidePreviewHtmlString: any = null;
    EducationArrayList: Array<Education>;
    WorkArrayList: Array<Work>;
    EducationDataSource: EducationDetails[];
    AuditTrail: any;
    ViewAuditTrail: boolean = false;
    auditTrailColumns = [
        { field: 'ID', header: 'Record ID' },
        { field: 'Action', header: 'Action' },
        { field: 'FieldName', header: 'Field Name' },
        { field: 'OldValue', header: 'Old Value' },
        { field: 'NewValue', header: 'New Value' },
        { field: 'name', header: 'Created By' },
        { field: 'CreatedOn', header: 'Created On' }
    ];

    EduObj = [{ Qualification: '', CouserName: '', CountryName: '', CityName: '', CourseType: '' }]
    constructor(public _resumeService: ResumeService, private status: HTTPStatus, private _activeRoute: ActivatedRoute,
        public _commonService: CommonService, public _alertService: AlertService, private _fb: FormBuilder,
        private error: AppErrorHandler, private _dataservice: DataService, private _router: Router,
        private _dialog: MatDialog, public _global: Global, private sanitizer: DomSanitizer, private progressService: ProgressService
        , private datepipe: DatePipe) { }

    placeholder = 'This field is optional and can be skipped.';

    ngOnInit() {
        this.YearOfExperience = [
            { Value: '0-5', Text: '0 to 5 Years' },
            { Value: '5-10', Text: '5 to 10 Years' },
            { Value: '10-15', Text: '10 to 15 Years' },
            { Value: '15-20', Text: '15 to 20 Years' },
            { Value: '20-60', Text: '20 Years and Above' }]
        if (!(this._activeRoute.snapshot.queryParams['param1'] == "" || this._activeRoute.snapshot.queryParams['param1'] == null)) {
            this.resumeID = this._commonService.DecryptData(this._activeRoute.snapshot.queryParams['param1']);
            //this.resumeID = this._commonService.DecryptData(this._activeRoute.snapshot.queryParams['ID']);
        }
        else {
            this.resumeID = "";
        }
        if (!(this._activeRoute.snapshot.queryParams['param2'] == "" || this._activeRoute.snapshot.queryParams['param2'] == null)) {
            this.empLPN = this._commonService.DecryptData(this._activeRoute.snapshot.queryParams['param2']) || null;
        }
        else {
            this.empLPN = null;
        }
        var objSearch = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', EngSector: '', MarketSegment: '', ResumeID: this.resumeID == "" ? 0 : this.resumeID, EmpLPN: this.empLPN == null ? '' : this.empLPN, Flag: 0 };
        this.ResumeCreationForm = this._fb.group({
            EmployeeId: [''],
            ResumeId: [0],
            EmployeeName: [''],
            EmployeeLPN: [''],
            Entity: [''],
            Designation: [''],
            MobileNumber: [''],
            EmployeeGPN: [''],
            SMU: [''],
            OfficeLocation: [''],
            //YearOfExp: [{ Value: '0-5', Text: '0 to 5 Years' }, Validators.required],
            YearOfExp: [{ Value: '0-5', Text: '0 to 5 Years' }],

            YearofExpDesc: [''],
            //Education: ['IGNORE', [Validators.required]],
            //PriorWorkExperience: ['IGNORE'],
            AdditionalComments: [''],
            AreaOfSpecialization: [[], [Validators.required]],
            AreaOfSpecializationDescr: [''],
            //Achievements: [''],
            AnyAdditionalLeadershipResponsibilities: [''],
            SectorFocus: [[], [Validators.required]],
            SectorFocusDescr: [''],
            SpecifyAreaOfSpecialization: [''],
            EmployeeEmail: [''],
            FileSource: [''],
            StatusID: [0],
            StatusDesc: [''],
            IsCreatedByDelegatee: [false],
            Mandates: [],
            EducationDetails: [[]],
            PrevWorkDetails: [],
            Qualification: [''],
            CourseName: [''],
            Country: [],
            CityName: [''],
            CourseType: [''],
            CompanyName: [''],
            PositionHeld: [''],
            FromDate: [''],
            ToDate: [''],
            PrevWorkExpDetails: [[]],
            IsApproved: [false],
            InstituteName: [''],
            Passingyear: ['']
        });
        this.EducationDetailForm = this._fb.group({
            Qualification: [''],
            CourseName: [''],
            CourseId: [0],
            Country: [],
            CountryName: [''],
            CountryId: [0],
            City: [''],
            CityId: [0],
            CityName: [''],
            CourseType: ['']

        });
        this.AuditTrail = [];
        this.GetFilterValues(objSearch);
        this.BindQualificationList();
        this.BindCountryList();
        this.BindCourseTypeList();
        //this.newRow('Work');
    }

    DraftRecord() {
        let errorMessage: string = "";
        let _sectorFocused: string = "";
        let _areaOfSpecialization: string = "";
        let _yearOfExperience: string = ""; debugger;
        if (this.ResumeCreationForm.controls.SectorFocus.value.length > 0) {
            _sectorFocused = this.ResumeCreationForm.controls.SectorFocus.value.map((item) => { return item.Value }).join(',')
        }
        if (this.ResumeCreationForm.controls.AreaOfSpecialization.value.length > 0) {
            _areaOfSpecialization = this.ResumeCreationForm.controls.AreaOfSpecialization.value.map((item) => { return item.Value }).join(',');
        }
        if (this.ResumeCreationForm.controls.YearOfExp.value != undefined && this.ResumeCreationForm.controls.YearOfExp.value != null) {
            _yearOfExperience = this.ResumeCreationForm.controls.YearOfExp.value.Value;
        }
        // if(this.EducationArrayList !=null || this.EducationArrayList != undefined)
        // {
        //     if(this.EducationArrayList.length>0)
        //     {
        //     for(let i=0;i<this.EducationArrayList.length;i++)
        //     {
        //         if(this.EducationArrayList[i].Qualification=="" || this.EducationArrayList[i].CourseName==""||this.EducationArrayList[i].CountryName==""||this.EducationArrayList[i].CityName==""||this.EducationArrayList[i].InstituteName==""||this.EducationArrayList[i].PassingYear=="")
        //         {
        //            return this._alertService.notify('error', 'error!', "Value cannot left bank at row "+(i+1)+" in Education Details");
        //         }
        //     }
        //     }
        // }
        // if(this.WorkArrayList!=null || this.WorkArrayList!=undefined)
        // {
        //     if(this.WorkArrayList.length>0)
        //     {
        //         for(let i=0;i<this.WorkArrayList.length;i++)
        //         {
        //             if(this.WorkArrayList[i].CompanyName=="" || this.WorkArrayList[i].PositionHeld==""||this.WorkArrayList[i].FromDate==""||this.WorkArrayList[i].ToDate==""||this.WorkArrayList[i].CountryName==""||this.WorkArrayList[i].CityName=="")
        //             {
        //                 return this._alertService.notify('error', 'error!', "Value cannot left bank at row "+(i+1)+" in Previous Work Details");
        //             }
        //         }
        //     }
        // }

        this.ResumeCreationForm.patchValue({
            StatusID: Actions.SaveasDraft,
            SectorFocus: _sectorFocused,
            AreaOfSpecialization: _areaOfSpecialization,
            YearOfExp: _yearOfExperience,
            Mandates: this.selectedMandates
            , EducationDetails: this.EducationArrayList
            , PrevWorkExpDetails: this.WorkArrayList
        });
        this._resumeService.AddResume(this.ResumeCreationForm.value).subscribe(data => {
            debugger
            if (data.IsSuccess) {
                this._alertService.notify('success', 'Success!', 'Resume Saved Successfully.');

            } else {
                this._alertService.notify('error', 'error!', data.Message);
            }
            if (this.resumeID) {
                this.GetResume(this.resumeID, "resumeId");
            }
            else if (this.empLPN) {
                this.GetResume(this.empLPN, "empLPN");
            }
            else {
                this.GetResume(null, null);
            }
        }, (error) => {
            this.error.handleError(error);
        },
            () => {
            });
    }

    SaveResume() {

        //for (const field in this.ResumeCreationForm.controls) { 
        //    console.log(field, this.ResumeCreationForm.get(field).valid);
        //}

        let errorMessage: string = "";
        if (!this.ResumeCreationForm.valid) {
            errorMessage = "Please fill mandatory fields.";
        }
        if (this.uploadedFiles == "") {
            errorMessage = errorMessage.length > 0 ? "\nPhoto is required." : "Photo is required.";
        }
        let mandatesSelected: number = this.selectedMandates.length;
        if (mandatesSelected > 0) {
            let _filterMandate: any = [];
            _filterMandate = this.selectedMandates.filter(x => x.Priority < 1 || x.Priority > mandatesSelected);
            if (_filterMandate.length > 0) {
                errorMessage = errorMessage.length > 0 ? "\nMandates Priorities are incorrect." : "Mandates Priorities are incorrect.";
            }
        }
        debugger
        if (errorMessage != "") {
            alert(errorMessage);
            return false;
        }
        if (this.selectedMandates != null && this.selectedMandates.length > 0) {
            const status = this.selectedMandates.some(mandate => {
                let counter = 0;
                for (const iterator of this.selectedMandates) {
                    if (iterator.Priority === mandate.Priority) {
                        counter += 1;
                    }
                }
                return counter > 1;
            });
            if (status) {
                return this._alertService.notify('error', 'error!', "Priority cannot be duplicate.");
            }
        }

        if (this.EducationArrayList == null || this.EducationArrayList == undefined) {
            return this._alertService.notify('error', 'error!', "Please enter Education Details");
        }
        //if (this.WorkArrayList == null || this.WorkArrayList == undefined) {
        //    return this._alertService.notify('error', 'error!', "Please enter Previous Work Details");
        //}
        if (this.EducationArrayList != null || this.EducationArrayList != undefined) {
            if (this.EducationArrayList.length > 0) {
                for (let i = 0; i < this.EducationArrayList.length; i++) {
                    if (this.EducationArrayList[i].Qualification == "" || this.EducationArrayList[i].CourseName == "" || this.EducationArrayList[i].CountryName == "" || this.EducationArrayList[i].CityName == "" || this.EducationArrayList[i].InstituteName == "" || this.EducationArrayList[i].PassingYear == "") {
                        return this._alertService.notify('error', 'error!', "Value cannot left bank at row " + (i + 1) + " in Education Details");
                    }
                }
            }
        }
        if (this.WorkArrayList != null || this.WorkArrayList != undefined) {
            if (this.WorkArrayList.length > 0) {
                for (let i = 0; i < this.WorkArrayList.length; i++) {
                    if (this.WorkArrayList[i].CompanyName == "" || this.WorkArrayList[i].PositionHeld == "" || this.WorkArrayList[i].FromDate == "" || this.WorkArrayList[i].ToDate == "" || this.WorkArrayList[i].CountryName == "" || this.WorkArrayList[i].CityName == "") {
                        return this._alertService.notify('error', 'error!', "Value cannot left bank at row " + (i + 1) + " in Previous Work Details");
                    }
                }
            }
        }
        this.ResumeCreationForm.patchValue({
            StatusID: Actions.Submit,
            SectorFocus: this.ResumeCreationForm.controls.SectorFocus.value.map((item) => { return item.Value }).join(','),
            AreaOfSpecialization: this.ResumeCreationForm.controls.AreaOfSpecialization.value.map((item) => { return item.Value }).join(','),
            YearOfExp: this.ResumeCreationForm.controls.YearOfExp.value.Value,
            Mandates: this.selectedMandates,
            EducationDetails: this.EducationArrayList, PrevWorkExpDetails: this.WorkArrayList
        });

        this._resumeService.AddResume(this.ResumeCreationForm.value).subscribe(data => {
            if (data.IsSuccess) {
                // this._alertService.notify('success', 'Success!', data.Message);
                this._alertService.notify('success', 'Success!', 'Resume Submitted Successfully.');
                this._router.navigate(['home/my-resume']);

            } else {
                this._alertService.notify('error', 'error!', data.Message);
            }
        }, (error) => {
            this.error.handleError(error);
        },
            () => {
            });
    }

    GetResume(val: any, type: string) {
        this.status.setHttpStatus(true);
        this.blockedUI = true;

        this.CanSaveForm = false;
        this.CanEditForm = false;
        this.CanApproveRejectForm = false;
        this.IsFormEditable = false;

        this._resumeService.GetResume(val, type).subscribe(data => {
            this.StatusDesc = data.StatusDesc;
            this.CanSaveForm = data.CanSaveForm;
            this.CanEditForm = data.CanEditForm;
            this.CanApproveRejectForm = data.CanApproveRejectForm;

            if (this.CanSaveForm || this.CanApproveRejectForm) {
                this.IsFormEditable = true;
            }

            this.EmpGPN = data.EmployeeGPN;
            this.ResID = data.ResumeId;
            this.ResumeCreationForm.patchValue({
                EmployeeLPN: data.EmployeeLPN,
                ResumeId: data.ResumeId,
                EmployeeName: data.EmployeeName + '(' + data.EmployeeEmail + ')',
                Entity: data.Entity,
                Designation: data.Designation,
                MobileNumber: data.MobileNumber,
                EmployeeGPN: data.EmployeeGPN,
                YearOfExp: this.BindExperience(data.YearOfExp),
                SMU: data.SMU,
                StatusDesc: data.StatusDesc,
                OfficeLocation: data.OfficeLocation,
                Education: data.Education,
                PriorWorkExperience: data.PriorWorkExperience,
                AdditionalComments: data.AdditionalComments,
                AreaOfSpecialization: this.BindSpecialization(data.AreaOfSpecialization),
                Achievements: data.Achievements,
                AnyAdditionalLeadershipResponsibilities: data.AnyAdditionalLeadershipResponsibilities,
                SectorFocus: this.BindSectorFocused(data.SectorFocus),
                SpecifyAreaOfSpecialization: data.SpecifyAreaOfSpecialization,
                EmployeeEmail: data.EmployeeEmail,
                StatusID: data.StatusID,
                IsCreatedByDelegatee: data.IsCreatedByDelegatee
                , YearofExpDesc: data.YearofExpDesc
                , AreaOfSpecializationDescr: data.AreaOfSpecializationDescr
                , SectorFocusDescr: data.SectorFocusDescr
                , IsApproved: data.IsApproved
            });
            this.GetMandatesByResumeId(data.EmployeeGPN, data.ResumeId);
            this.GetImageForBinding();
            this.GetAllAuditTrailByID(data.ResumeId, "ResumeDetails");
            debugger
            if (data.EducationDetails != null && data.EducationDetails.length > 0) {
                this.EducationArrayList = data.EducationDetails;
                if (this.EducationArrayList.length > 0) {
                    for (let i = 0; i < this.EducationArrayList.length; i++) {
                        this.EducationArrayList[i].PassingYear = this.datepipe.transform(this.EducationArrayList[i].PassingYear, "dd-MMM-yyyy");
                    }
                }
            }

            if (data.PrevWorkExpDetails != null && data.PrevWorkExpDetails.length > 0) {
                this.WorkArrayList = data.PrevWorkExpDetails;
                if (this.WorkArrayList.length > 0) {
                    for (let i = 0; i < this.WorkArrayList.length; i++) {
                        this.WorkArrayList[i].FromDate = this.datepipe.transform(this.WorkArrayList[i].FromDate, "dd-MMM-yyyy");
                        this.WorkArrayList[i].ToDate = this.datepipe.transform(this.WorkArrayList[i].ToDate, "dd-MMM-yyyy");
                    }
                }
            }
            // else
            // {
            //     this.newRow('Work');
            // }

        }, (error) => {
            this.status.setHttpStatus(false);
            this.error.handleError(error);
        },
            () => { this.status.setHttpStatus(false); });
    }

    GetFormControls(controlName) {
        return this.ResumeCreationForm.controls[controlName];
    }

    preview(files) {
        if (files.length === 0)
            return;

        var mimeType = files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            alert("Only images are supported.");
            return;
        }

        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
            this.imgURL = reader.result;
        }
    }

    deleteImage(url: any): void {
        this.imgURL = null;
    }

    OnFilterSelection() {
        var objSearch = { loginEmpGPN: '', EngSMU: '', EngType: '', EngSubType: '', EngSector: '', MarketSegment: '', Designation: '' };
        objSearch.EngType = this.SelectedEngTypeList.map((item) => { return item.Value }).join(',');
        objSearch.EngSector = this.SelectedEngSectorList.map((item) => { return item.Value }).join(',');

    }

    GetFilterValues(serchObj: any = null) {
        this.blockedUI = true;
        console.log(serchObj);
        this._dataservice.PostData("GetResumeSearchFilters", serchObj).subscribe((data: any) => {
            console.log(data);
            
            this.EngTypeList = data.Table8;
            this.SelectedEngTypeList = [];
            this.EngSectorList = data.Table4;
            this.SelectedEngSectorList = [];
            if (this.resumeID) {
                this.GetResume(this.resumeID, "resumeId");
            }
            else if (this.empLPN) {
                this.GetResume(this.empLPN, "empLPN");
            }
            else {
                this.GetResume(null, null);
            }
        });
    }


    uploadFile(uploadedFiles: any) {

        if (uploadedFiles.files.length === 0)
            return;

        const maxLength = 1024 * 1024 * 2;
        for (let file of uploadedFiles.files) {
            const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (fileExtension.toLowerCase() === 'jpg'
                || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'png') {

                if (file.size > maxLength) {
                    alert('File size can not be more than 2 mb.');
                    return;
                }
                debugger
                let empGPN: string = this.ResumeCreationForm.controls.EmployeeGPN.value;
                this._commonService.UploadFile(uploadedFiles.files, empGPN).subscribe((event: any) => {
                    debugger
                    if (event != null) {
                        if (event.IsSuccess == false) {
                            alert(event.Message);
                            window.location.reload();
                        } else {
                            var resp: any = event;
                            this.uploadedFiles = resp;
                            alert('File uploaded successfully');
                        }

                    }
                }, error => {
                    debugger
                    console.log('error');
                })
            }
            else {
                alert('File Extension Is InValid - Upload JPEG/PNG Image only');
            }
        }

    }

    OpenMandates() {
        this.ViewMandateSelection = true;
    }
    OpenEducation(templateRef) {
        //this.VisibleEducationDialog = true;
        if (this.EducationDetailForm != undefined) {
            this.CountryList = [];
            this.CityList = [];
            this.BindCountryList();
        }
        let dialogRef = this._dialog.open(templateRef, {
            width: '90%',
            height: '550px',
            disableClose: true
        });
    }
    onEducationRowSelect(event, templateRef) {
        debugger
        var TestPanelDataSelected = this.EducationDataSource[this.EducationDataSource.indexOf(this.selectedEduDetails)]
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '90%';
        dialogConfig.height = '550px';

        dialogConfig.data = {
            TestPanelDataSelected
        };

        let dialogRef = this._dialog.open(templateRef, dialogConfig);

        this.EducationDetailForm.controls.Qualification.setValue(TestPanelDataSelected.Qualification);
        this.EducationDetailForm.controls.CourseName.setValue(TestPanelDataSelected.CourseName);
        this.EducationDetailForm.controls.CountryName.setValue(TestPanelDataSelected.CourseName);
        this.EducationDetailForm.controls.CountryId.setValue(TestPanelDataSelected.CountryId);
        this.EducationDetailForm.controls.Country.setValue(TestPanelDataSelected.CountryName);
        this.EducationDetailForm.controls.City.setValue(TestPanelDataSelected.CityName);
        this.EducationDetailForm.controls.CityId.setValue(TestPanelDataSelected.CityId);
        this.EducationDetailForm.controls.CityName.setValue(TestPanelDataSelected.CityName);
        this.EducationDetailForm.controls.CourseType.setValue(TestPanelDataSelected.CourseType);
        this.EducationDetailForm.controls.Country.setValue(TestPanelDataSelected.Country);
        this.EducationDetailForm.controls.City.setValue(TestPanelDataSelected.City);

    }
    addEducationDtls() {
        if (this.EducationDetailForm.controls.Qualification.value == null || this.EducationDetailForm.controls.Qualification.value == "") {
            alert('Please enter Qualification.');
            return false;
        }
        if (this.EducationDetailForm.controls.CourseName.value == null || this.EducationDetailForm.controls.CourseName.value == "") {
            alert('Please enter Course Name.');
            return false;
        }
        if (this.EducationDetailForm.controls.CountryId.value.CountryId == null || this.EducationDetailForm.controls.CountryId.value.CountryId == "") {
            alert('Please select Country.');
            return false;
        }
        if (this.EducationDetailForm.controls.City.value.CityName == null || this.EducationDetailForm.controls.City.value.CityName == "") {
            alert('Please select City.');
            return false;
        }
        if (this.EducationDetailForm.controls.CourseType.value == null || this.EducationDetailForm.controls.CourseType.value == "") {
            alert('Please enter Course Type.');
            return false;
        }
        debugger;
        let objcustom = new EducationDetails();
        objcustom.EducationDetailsId = 0;
        objcustom.ResumeId = this.ResumeCreationForm.controls.ResumeId.value;
        objcustom.Qualification = this.EducationDetailForm.controls.Qualification.value;
        objcustom.CourseName = this.EducationDetailForm.controls.CourseName.value;
        objcustom.CountryName = this.EducationDetailForm.controls.CountryName.value;
        objcustom.CountryId = this.EducationDetailForm.controls.CountryId.value.CountryId;
        objcustom.CityName = this.EducationDetailForm.controls.City.value.CityName;
        objcustom.CityId = this.EducationDetailForm.controls.City.value.CityId;
        objcustom.CourseType = this.EducationDetailForm.controls.CourseType.value;
        objcustom.Country = this.EducationDetailForm.controls.CountryId.value;
        objcustom.City = this.EducationDetailForm.controls.City.value;
        //this.EducationArrayList.push(objcustom);
        //this.EducationDataSource=this.EducationArrayList;
        this.EducationReset();
    }
    updateEducationDtls() {
        debugger
        this.EducationDetailForm.controls.Qualification.patchValue(this.EducationDetailForm.controls.Qualification.value);
        this.EducationDetailForm.controls.CourseName.patchValue(this.EducationDetailForm.controls.CourseName.value);
        this.EducationDetailForm.controls.CountryName.patchValue(this.EducationDetailForm.controls.CountryName.value);
        this.EducationDetailForm.controls.CountryId.patchValue(this.EducationDetailForm.controls.CountryId.value.CountryId);
        this.EducationDetailForm.controls.Country.patchValue(this.EducationDetailForm.controls.CountryId.value);
        this.EducationDetailForm.controls.City.patchValue(this.EducationDetailForm.controls.City.value);
        this.EducationDetailForm.controls.CityId.patchValue(this.EducationDetailForm.controls.City.value.CityId);
        this.EducationDetailForm.controls.CityName.patchValue(this.EducationDetailForm.controls.City.value.CityName);
        this.EducationDetailForm.controls.CourseType.patchValue(this.EducationDetailForm.controls.CourseType.value);
        alert('Details has been updated successfully.');
        this.EducationReset();
    }
    EducationReset() {
        this.EducationDetailForm.controls.Qualification.reset();
        this.EducationDetailForm.controls.CourseName.reset();
        this.EducationDetailForm.controls.CountryName.reset();
        this.EducationDetailForm.controls.CityName.reset();
        this.EducationDetailForm.controls.CourseType.reset();
        this.EducationDetailForm.controls.CountryId.reset();
        this.EducationDetailForm.controls.City.reset();
        this.EducationDetailForm.controls.CityId.reset();
        this.EducationDetailForm.controls.Country.reset()
    }
    OpenPrevWork() {
        this.VisibleprevWorkDialog = true;
    }

    BindSectorFocused(sf) {
        let _selected: any = [];
        if (sf.length > 0) {
            let _sectorFocused: Array<number> = sf.split(",");
            for (var val of _sectorFocused) {
                let p = this.EngSectorList.filter(x => x.Value == val);
                if (p) {
                    _selected.push(p[0]);
                }
            }
        }
        return _selected;
    }

    BindSpecialization(sf) {
        let _selected: any = [];
        if (sf.length > 0) {
            let _specialization: Array<number> = sf.split(",");
            for (var val of _specialization) {
                let p = this.EngTypeList.filter(x => x.Value == val);
                if (p) {
                    _selected.push(p[0]);
                }
            }
        }
        return _selected;
    }

    BindExperience(sf) {
        let p = this.YearOfExperience.filter(x => x.Value == sf);
        return p[0];
    }

    GetMandatesByResumeId(empGPN: string, resumeid: number) {
        let _url: string = "Resume/GetMandateList";
        this._dataservice.PostData(_url, { Param1: empGPN, Param2: resumeid }).subscribe(data => {
            this.Mandates = data;
            this.selectedMandates = this.Mandates.filter(x => x.IsSelected == true);
        });
    }

    GetImageForBinding() {
        let empGPN: string = this.ResumeCreationForm.controls.EmployeeGPN.value;
        let _url: string = "Resume/GetImage";
        this._dataservice.PostData(_url, { Param1: empGPN }).subscribe(data => {
            this.uploadedFiles = data;
            this.blockedUI = false;
        });
    }

    RemovePhoto() {
        this.uploadedFiles = '';
        let empGPN: string = this.ResumeCreationForm.controls.EmployeeGPN.value;
        let _url: string = "Common/RemoveImage";
        this._dataservice.PostData(_url, { Param1: empGPN }).subscribe((data: any) => {

            if (data.IsSuccess) {
                alert(data.Message)
            }
        });
    }
    priorityChanged($event, _priority): void {
        let selectedItems: number = this.selectedMandates.length;
        if (isNaN($event.target.value)) {
            $event.target.value = 0;
            //alert('Kindly input numbers between 1 and 10 only');
        }
        else if (_priority <= 0 || _priority > selectedItems) {
            $event.target.value = 0;
            //alert('Kindly input numbers between 1 and 10 only');
        }
        $event.stopPropagation();
        return;
    }

    onRowSelect(event) {
        let selectedItems: number = this.selectedMandates.length;
        if (selectedItems > 10) {
            this.selectedMandates.splice(selectedItems - 1, 1);
            alert('Only 10 mandates can be added!');
        }
    }
    showDialogMaximized(event, dialog: Dialog) {
        dialog.maximized = false;
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }
    PreiewResume() {
        this.slidePreviewHtmlString = null;
        this.displaySelectedSlidePreviewDialog = false;
        this.showPreviewProgress = true;
        this.downloadButtonTitle = "Downloading";

        if (!this.ResumeCreationForm.valid) {
            alert("Please fill mandatory fields and save your form before previewing.");
            return;
        }
        if (this.uploadedFiles.length <= 0) {
            alert('Please fill mandatory fields and save your form before previewing.');
            return;
        }
        else {
            this.displaySelectedSlidePreviewDialog = true;
            let _url: string = "PreviewResume"
            let _resumeToPreview: any = { ResumeId: this.ResumeCreationForm.controls.ResumeId.value, StatusID: 0, EmployeeGPN: this.ResumeCreationForm.controls.EmployeeGPN.value };
            this._dataservice.PostData(_url, _resumeToPreview).subscribe((data: string) => {
                this.slidePreviewHtmlString = this.sanitizer.bypassSecurityTrustHtml(data);
                this.downloadButtonTitle = "Download";
                this.showPreviewProgress = false;
            });
        }
    }
    DownloadResume() {
        let _url = "DownloadResume";
        let _resumeToPreview: any = { ResumeId: this.ResumeCreationForm.controls.ResumeId.value, StatusID: 0, EmployeeGPN: this.ResumeCreationForm.controls.EmployeeGPN.value };
        this._dataservice.DownloadFileWithPost(_url, _resumeToPreview).subscribe((data: any) => {
            const blob = new Blob([data], { type: 'application/octet-stream' });
            saveAs(blob, 'myResume.pptx');
        }, error => {
            console.log('error');
        });
    }
    EditForm() {
        this.CanEditForm = false;
        this.CanApproveRejectForm = false;
        this.CanSaveForm = true;
        this.IsFormEditable = true;
    }
    ApproveRejectForm(StatusID: number) {
        let errorMessage: string = "";
        let StatusDesc: string = "";
        let IsApproved: boolean = false;
        if (!this.ResumeCreationForm.valid) {
            errorMessage = "Please fill mandatory fields.";
        }

        if (errorMessage != "") {
            alert(errorMessage);
            return false;
        }
        if (StatusID == 1) {
            StatusDesc = "Draft";
        }
        else if (StatusID == 2) {
            StatusDesc = "Submitted";
            IsApproved = true;
        }
        debugger

        this.ResumeCreationForm.patchValue({
            StatusID: StatusID,
            StatusDesc: StatusDesc,
            IsApproved: IsApproved,
            SectorFocus: this.ResumeCreationForm.controls.SectorFocus.value.map((item) => { return item.Value }).join(','),
            AreaOfSpecialization: this.ResumeCreationForm.controls.AreaOfSpecialization.value.map((item) => { return item.Value }).join(','),
            YearOfExp: this.ResumeCreationForm.controls.YearOfExp.value.Value,
            Mandates: this.selectedMandates,
            EducationDetails: this.EducationArrayList, PrevWorkExpDetails: this.WorkArrayList
        });

        this._resumeService.AddResume(this.ResumeCreationForm.value).subscribe(data => {
            if (data.IsSuccess) {
                if (StatusID == 1) {
                    this._alertService.notify('success', 'Success!', 'Resume Returned Successfully.');
                } else {
                    this._alertService.notify('success', 'Success!', 'Resume Approved Successfully.');
                }
                this._router.navigate(['home/my-resume']);

            } else {
                this._alertService.notify('error', 'error!', data.Message);
            }
        }, (error) => {
            this.error.handleError(error);
        },
            () => {
            });

    }
    RejectForm(StatusID: number) {
        let errorMessage: string = "";
        if (!this.ResumeCreationForm.valid) {
            errorMessage = "Please fill mandatory fields.";
        }

        if (errorMessage != "") {
            alert(errorMessage);
            return false;
        }
        debugger
        this.ResumeCreationForm.patchValue({
            StatusID: Actions.SaveasDraft
        });

        this._resumeService.RejectForm(this.ResumeCreationForm.value).subscribe(data => {
            if (data.IsSuccess) {
                this._alertService.notify('success', 'Success!', data.Message);
                this._router.navigate(['home/my-resume']);

            } else {
                this._alertService.notify('error', 'error!', data.Message);
            }
        }, (error) => {
            this.error.handleError(error);
        },
            () => {
            });
    }


    BindCountryList() {
        this._commonService.BindCountryList().subscribe((result: any) => {
            debugger
            this.CountryList = result.Table;

        });
    }
    CountryonChange($event, i, type) {
        debugger
        if (type == 'Education') {
            this.EducationDetailForm.controls.CountryId.setValue($event.value);
            this.EducationDetailForm.controls.CountryName.setValue($event.value.CountryName);
            this.EducationArrayList[i].CountryId = $event.value.CountryId;
            this.EducationArrayList[i].CountryName = $event.value.CountryName;
        } else {
            this.EducationDetailForm.controls.CountryId.setValue($event.value);
            this.EducationDetailForm.controls.CountryName.setValue($event.value.CountryName);
            this.WorkArrayList[i].CountryId = $event.value.CountryId;
            this.WorkArrayList[i].CountryName = $event.value.CountryName;
        }

    };

    BindQualificationList() {
        this._commonService.BindQualificationList().subscribe((result: any) => {
            debugger
            this.QualificationList = result;

        });
    }
    QualificationOnChange($event, i) {
        debugger
        this.EducationDetailForm.controls.Qualification.setValue($event.value);
        this.EducationArrayList[i].SelectedQualification = $event.value;
        this.EducationArrayList[i].QualificationId = $event.value.QualificationId;
        this.EducationArrayList[i].Qualification = $event.value.QualificationName;
    };
    BindCourseTypeList() {
        this._commonService.BindCourseTypeList().subscribe((result: any) => {
            debugger
            this.CourseTypeList = result;

        });
    }
    CourseTypeOnChange($event, i) {
        debugger
        this.EducationArrayList[i].CourseTypeId = $event.value.CourseTypeId;
        this.EducationArrayList[i].CourseType = $event.value.CourseType;
    };
    GetCitiesByCountyID = (event, i, type) => {
        let countryid: string;
        if (type == 'Education') {
            countryid = this.EducationArrayList[i].CountryId;
        } else {
            countryid = this.WorkArrayList[i].CountryId;
        }
        this._commonService.BindCityByCountryCode(event.query, countryid).subscribe((data: any) => {
            this.CityList = data.Table;
        });
    }
    OnCitySelection(event, i, type) {
        debugger
        if (type == 'Education') {
            this.EducationArrayList[i].CityName = event.CityName;
            this.EducationArrayList[i].CityId = event.CityId;
        } else {
            this.WorkArrayList[i].CityName = event.CityName;
            this.WorkArrayList[i].CityId = event.CityId;
        }

    }

    GetCourseByQualificationId = (event, i) => {
        this._commonService.BindCourseByQualification(event.query, this.EducationArrayList[i].QualificationId).subscribe((data: any) => {
            this.CourseList = data;
        });
    }
    CourseOnCSelection(event, i) {
        debugger
        this.EducationArrayList[i].Course = event;
        this.EducationArrayList[i].CourseName = event.CourseName;
        this.EducationArrayList[i].CourseId = event.CourseID;

    }

    newRow(type) {
        debugger
        if (type == 'Education') {
            if (this.EducationArrayList == undefined) {
                this.EducationArrayList = [{ Id: 0, Qualification: '', SelectedQualification: {}, QualificationId: '', Course: [], CourseName: '', CourseId: 0, SelectedCourseType: {}, Country: '', CountryName: '', CountryId: '', City: [], CityId: 0, CityName: '', CourseType: '', CourseTypeId: 0, InstituteName: '', PassingYear: '' }]

            } else {
                this.EducationArrayList.push({ Id: 0, Qualification: '', SelectedQualification: {}, QualificationId: '', Course: [], CourseName: '', CourseId: 0, SelectedCourseType: {}, Country: '', CountryName: '', CountryId: '', City: [], CityId: 0, CityName: '', CourseType: '', CourseTypeId: 0, InstituteName: '', PassingYear: '' });
            }
        }
        else {
            if (this.WorkArrayList == undefined) {
                this.WorkArrayList = [{ Id: 0, ResumeId: 0, CompanyName: '', PositionHeld: '', FromDate: '', ToDate: '', CountryName: '', CountryId: '', City: [], CityId: 0, CityName: '' }]

            } else {
                this.WorkArrayList.push({ Id: 0, ResumeId: 0, CompanyName: '', PositionHeld: '', FromDate: '', ToDate: '', CountryName: '', CountryId: '', City: [], CityId: 0, CityName: '' });
            }
        }

    }
    RemoveRowSelect(event, type) {
        debugger
        if (type == 'Education') {
            var delBtn = confirm(" Do you want to delete ?");
            if (delBtn == true) {
                this.EducationArrayList.splice(event, 1);
            }
        } else {
            var delBtn = confirm(" Do you want to delete ?");
            if (delBtn == true) {
                this.WorkArrayList.splice(event, 1);
            }
        }

    }
    ConvertintoDate(str) {
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        let current_datetime = new Date(str)
        let formatted_date = current_datetime.getDate() + "-" + months[current_datetime.getMonth()] + "-" + current_datetime.getFullYear()
        return formatted_date;
    }
    onDateSelect(event, type, i) {
        debugger
        if (type == 'From') {
            this.WorkArrayList[i].FromDate = this.datepipe.transform(event, 'dd-MMM-yyyy');
        }
        else if (type == "To") {
            this.WorkArrayList[i].ToDate = this.datepipe.transform(event, 'dd-MMM-yyyy');
        } else {
            this.EducationArrayList[i].PassingYear = this.datepipe.transform(event, 'dd-MMM-yyyy');
        }

    }
    OnCourseClear(i) {
        debugger
        this.EducationArrayList[i].CourseId = 0;
        this.EducationArrayList[i].CourseName = "";
        this.EducationArrayList[i].Course = null;
    }
    OnCityClear(i, type) {
        if (type == 'Education') {
            this.EducationArrayList[i].CityId = 0;
            this.EducationArrayList[i].CityName = "";
            this.EducationArrayList[i].City = null;
        } else {
            this.WorkArrayList[i].CityId = 0;
            this.WorkArrayList[i].CityName = "";
            this.WorkArrayList[i].City = null;
        }

    }
    OpenAuditTrail() {
        this.ViewAuditTrail = true;
    }
    GetAllAuditTrailByID(id: any, className: string) {
        this._commonService.GetAllAuditTrailByID(id, className).subscribe((result: any) => {
            debugger
            this.AuditTrail = result;

        });
    }
    YearofExpOnChange($event) {
        debugger
        this.ResumeCreationForm.controls.YearofExpDesc.setValue($event.value.Text);
    }
    AreaofSpztnOnChange($event) {
        debugger
        let areaofsplztnText: String = "";
        if (this.ResumeCreationForm.controls.AreaOfSpecialization.value != "") {
            if (this.ResumeCreationForm.controls.AreaOfSpecialization.value.length > 0) {
                for (let i = 0; i < this.ResumeCreationForm.controls.AreaOfSpecialization.value.length; i++) {
                    if (areaofsplztnText == "") {
                        areaofsplztnText = this.ResumeCreationForm.controls.AreaOfSpecialization.value[i].Text;
                    }
                    else {
                        areaofsplztnText = areaofsplztnText + "," + this.ResumeCreationForm.controls.AreaOfSpecialization.value[i].Text;
                    }
                }
                this.ResumeCreationForm.controls.AreaOfSpecializationDescr.setValue(areaofsplztnText);
            }
        }
    }
    SectorOnChange($event) {
        debugger
        let sectorFocusText: String = "";
        if (this.ResumeCreationForm.controls.SectorFocus.value != "") {
            if (this.ResumeCreationForm.controls.SectorFocus.value.length > 0) {
                for (let i = 0; i < this.ResumeCreationForm.controls.SectorFocus.value.length; i++) {
                    if (sectorFocusText == "") {
                        sectorFocusText = this.ResumeCreationForm.controls.SectorFocus.value[i].Text;
                    }
                    else {
                        sectorFocusText = sectorFocusText + "," + this.ResumeCreationForm.controls.SectorFocus.value[i].Text;
                    }
                }
                this.ResumeCreationForm.controls.SectorFocusDescr.setValue(sectorFocusText);
            }
        }
    }
}

export interface Education {
    Id: number;
    Qualification: any;
    SelectedQualification: any;
    QualificationId: string;
    Course: [];
    CourseName: string;
    CourseId: number;
    Country: any;
    CountryName: string;
    CountryId: string;
    City: [],
    CityId: number;
    CityName: string;
    SelectedCourseType: any;
    CourseType: string;
    CourseTypeId: number;
    InstituteName: string;
    PassingYear: any;
}
export interface Work {
    Id: number;
    ResumeId: number;
    CompanyName: string;
    PositionHeld: string;
    FromDate: any;
    ToDate: any;
    CountryName: string;
    CountryId: string;
    City: [],
    CityId: number;
    CityName: string;
}
export interface IAuditTrail {
    RecordID: string;
    Action: string;
    DisplayName: string;
    OldValue: string;
    NewValue: string;
    CreatedBy: string;
    CreatedOn: string;
    ClientDevice: string;
}
